
import { defineComponent } from "vue";

export default defineComponent({
  name: "MdHint",
  props: {
    icon: String,
  },
});
